import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import axios from "axios";
import { Api_Url } from "../../../config/config";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

function ResetPassword() {
  const navigate = useNavigate()

  const { email, temptoken } = useParams();

  console.log("tookkkk", email, temptoken);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // console.log("object",email)

  const handleSubmit = async () => {
    try {
      const data = { password, confirmPassword ,email, token:temptoken };
      const response = await axios.post(
        `${Api_Url}api/Account/reset-password`,
        data
      );
      console.log("response", response.data);
      if (response?.data?.succeeded) {
        SuccessToast("Password Reset Successfully");
        navigate("/login");
      } else {
        ErrorToast("Password reset failed. Please try again.");
      }
    } catch (error) {
      ErrorToast(error?.response?.data?.message);
      console.log("error", error);
    }
  };

  //   const handleSubmit =async () =>{
  //   try {
  //     const data = {email, Password, confirmPassword, token}
  // const response = await axios.post(`${}`)
  //     // console.log("res", response)
  //     // if (response.status === 200) {
  //     //   navigate('/')
  //     // }else {
  //     //   alert("not confirm password")
  //     // }
  //   } catch (error) {
  //     return error
  //   }
  //   }

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/admin-dashboard">
                  <img src={Applogo} alt="Roha housing" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Reset Password</h3>
                  <p className="account-subtitle">Access to our dashboard</p>
                  {/* Account Form */}
                  <div>
                    <form>
                      <div className="input-block mb-4">
                        <label className="col-form-label">Password</label>

                        <input
                          className={`form-control`}
                          type="password"
                          // defaultValue={localStorage.getItem("email")}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}

                          // autoComplete="true"
                        />
                        <span className="text-danger"></span>
                      </div>
                      <div className="input-block mb-4">
                        <div className="row">
                          <div className="col">
                            <label className="col-form-label">
                              Confirm password
                            </label>
                          </div>
                        </div>
                        <div style={{ position: "relative" }}>
                          <input
                            className={`form-control `}
                            type="password"
                            defaultValue={localStorage.getItem("password")}
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            // autoComplete="true"
                          />

                          <span
                            style={{
                              position: "absolute",
                              right: "5%",
                              top: "30%",
                            }}
                            className={`fa-solid`}
                          />
                        </div>
                        <span className="text-danger"></span>
                      </div>
                      <div className="input-block text-center">
                        <button
                          className="btn btn-primary account-btn"
                          type="button"
                          onClick={handleSubmit}
                        >
                          Change Password
                        </button>
                      </div>
                    </form>
                    <div className="account-footer">
                      <p>
                        Login with Mobile{" "}
                        <Link to="/loginwithmobile">Login</Link>
                      </p>
                    </div>
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
